import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import reducers from '../reducers';

export function getStore() {
  const middlewares = [thunk];

  let composeEnhancer = compose;

  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line import/no-extraneous-dependencies, global-require
    const { createLogger } = require('redux-logger');

    middlewares.push(
      createLogger({
        diff: true,
        collapsed: (getState, action, logEntry) => !logEntry.error,
      }),
    );

    composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  }

  /* eslint-enable */
  return createStore(reducers, composeEnhancer(applyMiddleware(...middlewares)));
}
